import app from "firebase/app";
import "firebase/auth";
import "firebase/database";

const prodConfig = {
  apiKey: "AIzaSyBCo4W6yWle1FH8jZhe8yhIENUuuGCi5nQ",
  authDomain: "dev-pandemic.firebaseapp.com",
  databaseURL: "https://dev-pandemic.firebaseio.com",
  projectId: "dev-pandemic",
  storageBucket: "dev-pandemic.appspot.com",
  messagingSenderId: "881104490800"
};

const devConfig = {
  apiKey: "AIzaSyBCo4W6yWle1FH8jZhe8yhIENUuuGCi5nQ",
  authDomain: "dev-pandemic.firebaseapp.com",
  databaseURL: "https://dev-pandemic.firebaseio.com",
  projectId: "dev-pandemic",
  storageBucket: "dev-pandemic.appspot.com",
  messagingSenderId: "881104490800"
};

const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.database();
  }

  // *** User API ***

  database = () => this.db.ref();
  playerOne = () => this.db.ref("playerOne")

  doCreateUserWithEmailAndPassword = (email, password) =>
  this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
  this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  //place method here to get user id (if needed)

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

}

export default Firebase;
